/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} About_Content_Honor_0_HeadingInputs */

const en_about_content_honor_0_heading = /** @type {(inputs: About_Content_Honor_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teaching & Section Honors`)
};

const es_about_content_honor_0_heading = /** @type {(inputs: About_Content_Honor_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Distinciones de enseñanza y de sección`)
};

const de_about_content_honor_0_heading = /** @type {(inputs: About_Content_Honor_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auszeichnungen für Lehre und Sektion`)
};

const zh_about_content_honor_0_heading = /** @type {(inputs: About_Content_Honor_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`教学与 PGA 分会荣誉`)
};

const ar_about_content_honor_0_heading = /** @type {(inputs: About_Content_Honor_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تكريمات التدريس وفرع PGA`)
};

const fr_about_content_honor_0_heading = /** @type {(inputs: About_Content_Honor_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Distinctions d’enseignement et de section`)
};

const vi_about_content_honor_0_heading = /** @type {(inputs: About_Content_Honor_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Danh hiệu giảng dạy và của phân hội PGA`)
};

const sw_about_content_honor_0_heading = /** @type {(inputs: About_Content_Honor_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tuzo za Ufundishaji na za Tawi la PGA`)
};

const th_about_content_honor_0_heading = /** @type {(inputs: About_Content_Honor_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`รางวัลด้านการสอนและจาก PGA ภาคไอโอวา`)
};

const bs_about_content_honor_0_heading = /** @type {(inputs: About_Content_Honor_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Priznanja u nastavi i sekciji`)
};

const ja_about_content_honor_0_heading = /** @type {(inputs: About_Content_Honor_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`指導・セクション表彰`)
};

const ko_about_content_honor_0_heading = /** @type {(inputs: About_Content_Honor_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`교습 및 PGA 섹션 수상`)
};

const pt_about_content_honor_0_heading = /** @type {(inputs: About_Content_Honor_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prêmios de ensino e da seção`)
};

const it_about_content_honor_0_heading = /** @type {(inputs: About_Content_Honor_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Riconoscimenti per l’insegnamento e della Sezione PGA`)
};

const sv_about_content_honor_0_heading = /** @type {(inputs: About_Content_Honor_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Utmärkelser för undervisning och från PGA-sektionen`)
};

const nl_about_content_honor_0_heading = /** @type {(inputs: About_Content_Honor_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Onderscheidingen voor lesgeven & de sectie`)
};

const da_about_content_honor_0_heading = /** @type {(inputs: About_Content_Honor_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Udmærkelser for undervisning og fra PGA-sektionen`)
};

const nb_about_content_honor_0_heading = /** @type {(inputs: About_Content_Honor_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Utmerkelser for undervisning og fra PGA-seksjonen`)
};

const fi_about_content_honor_0_heading = /** @type {(inputs: About_Content_Honor_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opetus- ja PGA-piirin kunnianosoitukset`)
};

const pl_about_content_honor_0_heading = /** @type {(inputs: About_Content_Honor_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wyróżnienia za nauczanie i od sekcji PGA`)
};

const ru_about_content_honor_0_heading = /** @type {(inputs: About_Content_Honor_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Награды за преподавание и от секции PGA`)
};

const tr_about_content_honor_0_heading = /** @type {(inputs: About_Content_Honor_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eğitmenlik ve PGA Bölgesi Ödülleri`)
};

const hi_about_content_honor_0_heading = /** @type {(inputs: About_Content_Honor_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`शिक्षण और PGA सेक्शन सम्मान`)
};

const id_about_content_honor_0_heading = /** @type {(inputs: About_Content_Honor_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Penghargaan Mengajar & Seksi`)
};

const ms_about_content_honor_0_heading = /** @type {(inputs: About_Content_Honor_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anugerah Pengajaran & Seksyen PGA`)
};

const cs_about_content_honor_0_heading = /** @type {(inputs: About_Content_Honor_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ocenění za výuku a od sekce PGA`)
};

const el_about_content_honor_0_heading = /** @type {(inputs: About_Content_Honor_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Διακρίσεις διδασκαλίας & του τμήματος PGA`)
};

const he_about_content_honor_0_heading = /** @type {(inputs: About_Content_Honor_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`פרסי הוראה ופרסי מחוז PGA`)
};

const af_about_content_honor_0_heading = /** @type {(inputs: About_Content_Honor_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eerbewyse vir onderrig en die seksie`)
};

const hu_about_content_honor_0_heading = /** @type {(inputs: About_Content_Honor_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oktatói és szekciós kitüntetések`)
};

/**
* | output |
* | --- |
* | "Teaching & Section Honors" |
*
* @param {About_Content_Honor_0_HeadingInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const about_content_honor_0_heading = /** @type {((inputs?: About_Content_Honor_0_HeadingInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<About_Content_Honor_0_HeadingInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_about_content_honor_0_heading(inputs)
	if (locale === "de") return de_about_content_honor_0_heading(inputs)
	if (locale === "zh") return zh_about_content_honor_0_heading(inputs)
	if (locale === "ar") return ar_about_content_honor_0_heading(inputs)
	if (locale === "fr") return fr_about_content_honor_0_heading(inputs)
	if (locale === "vi") return vi_about_content_honor_0_heading(inputs)
	if (locale === "sw") return sw_about_content_honor_0_heading(inputs)
	if (locale === "th") return th_about_content_honor_0_heading(inputs)
	if (locale === "bs") return bs_about_content_honor_0_heading(inputs)
	if (locale === "ja") return ja_about_content_honor_0_heading(inputs)
	if (locale === "ko") return ko_about_content_honor_0_heading(inputs)
	if (locale === "pt") return pt_about_content_honor_0_heading(inputs)
	if (locale === "it") return it_about_content_honor_0_heading(inputs)
	if (locale === "sv") return sv_about_content_honor_0_heading(inputs)
	if (locale === "nl") return nl_about_content_honor_0_heading(inputs)
	if (locale === "da") return da_about_content_honor_0_heading(inputs)
	if (locale === "nb") return nb_about_content_honor_0_heading(inputs)
	if (locale === "fi") return fi_about_content_honor_0_heading(inputs)
	if (locale === "pl") return pl_about_content_honor_0_heading(inputs)
	if (locale === "ru") return ru_about_content_honor_0_heading(inputs)
	if (locale === "tr") return tr_about_content_honor_0_heading(inputs)
	if (locale === "hi") return hi_about_content_honor_0_heading(inputs)
	if (locale === "id") return id_about_content_honor_0_heading(inputs)
	if (locale === "ms") return ms_about_content_honor_0_heading(inputs)
	if (locale === "cs") return cs_about_content_honor_0_heading(inputs)
	if (locale === "el") return el_about_content_honor_0_heading(inputs)
	if (locale === "he") return he_about_content_honor_0_heading(inputs)
	if (locale === "af") return af_about_content_honor_0_heading(inputs)
	if (locale === "hu") return hu_about_content_honor_0_heading(inputs)
	return en_about_content_honor_0_heading(inputs)
});